<nav class="navbar navbar-light bg-primary">
  <div class="px-3 me-2 fw-bold text-white">Cash book</div>
  <button
    type="button"
    class="btn btn-link text-white px-3 me-2 text-decoration-none"
    (click)="logout()"
  >
    Logout
  </button>
</nav>
